import React, { useRef, useState, useEffect, useMemo } from "react";
import { Popover, makeStyles } from "@material-ui/core";
import { useConfigs } from "../config-provider";
import Dropdown from "../dropdown";
import List from "./List";
import { useControlled } from "../utils";
var useStyles = makeStyles(function (theme) {
  return {
    noOptions: {
      color: theme.palette.text.secondary,
      padding: "14px 16px"
    }
  };
});

var Select = function Select(_a) {
  var label = _a.label,
      preLabel = _a.preLabel,
      isSearch = _a.isSearch,
      defaultValue = _a.value,
      startIcon = _a.startIcon,
      _b = _a.options,
      options = _b === void 0 ? [] : _b,
      onChange = _a.onChange,
      renderOption = _a.renderOption;
  var locale = useConfigs().locale;
  var classes = useStyles();
  var textRef = useRef(null);

  var _c = useState(false),
      open = _c[0],
      setOpen = _c[1];

  var _d = useControlled({
    controlled: defaultValue,
    default: ""
  }),
      value = _d[0],
      setValue = _d[1];

  var selected = useMemo(function () {
    return options && options.length !== 0 && value !== undefined && options.find(function (item) {
      return item.value === value;
    }) || null;
  }, [value, options]);

  var _e = useState(1),
      refresh = _e[1];

  useEffect(function () {
    refresh(0);
  }, []);

  function handleChange(option) {
    setOpen(false);
    setValue(option.value);
    onChange && onChange(option.value);
  }

  function handleClear() {
    setValue("");
    onChange && onChange("");
  }

  return React.createElement("div", null, React.createElement("div", {
    ref: textRef
  }, React.createElement(Dropdown, {
    preLabel: preLabel,
    label: label,
    value: selected && selected.label || "",
    startIcon: startIcon,
    open: open,
    onClick: function onClick() {
      return setOpen(true);
    },
    onClear: handleClear
  })), open && textRef && textRef.current && React.createElement(Popover, {
    open: true,
    anchorEl: textRef.current,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left"
    },
    onClose: function onClose() {
      return setOpen(false);
    }
  }, options.length === 0 ? React.createElement("div", {
    className: classes.noOptions
  }, locale.common.noOptions) : React.createElement(List, {
    options: options,
    renderOption: renderOption,
    isSearch: isSearch,
    selected: selected ? selected.value : "",
    onChange: handleChange
  })));
};

export default Select;